import React from 'react';

const BedRockContext = React.createContext();

export default BedRockContext;
